import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

import {
  PROCESS_DIALOG_CONTENT_PADDING,
  ProcessDialogContentVariant,
} from './types';

export interface ProcessDialogContentProps {
  children: ReactNode;
  variant?: ProcessDialogContentVariant;
  padding?: number | string;
}

const ProcessDialogContent: React.FC<ProcessDialogContentProps> = ({
  children,
  variant = 'default',
  padding,
}) => {
  const resolvedPadding = padding ?? PROCESS_DIALOG_CONTENT_PADDING[variant];

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        padding: resolvedPadding,
      }}
    >
      {children}
    </Box>
  );
};

export default ProcessDialogContent;
